<template>
  <div class="index_gw">
    <!-- 顶部 -->
    <div class="head">
      <img class="head_logo" src="../assets/img/logo.png" height="85%" alt="" />
      <div class="head_title">
        <div
          v-for="item in headlist"
          :key="item.id"
          :class="headIndex == item.id ? 'head_title_div1' : 'head_title_div'"
          @click="head(item.id)"
        >
          {{ item.title }}
        </div>
        <!-- <div class="head_title_div1" @click="login()">
          登录
        </div> -->
      </div>
    </div>
    <!-- 首页 -->
    <div style="height: 5rem"></div>
    <div class="body">
      <img :src="mainUrl" width="100%" alt="" />
    </div>
    <!-- 产品服务 -->
    <div class="body product">
      <div class="product_head">
        <div class="product_title">产品服务</div>
        <div class="product_title_item">
          互联网+大数据精细化管理---服务用户放心选择
        </div>
        <!-- <div class="product_title_item">汇合科技---校内课后服务系统提供商</div> -->
      </div>
      <!-- 轮播 -->
      <!-- <div class="product_rotation">
        <div class="product_rotation_title">
          <div
            @click="swipers(index)"
            :class="
              index == swiperIndex
                ? 'product_rotation_title_name1'
                : 'product_rotation_title_name'
            "
            v-for="(item, index) in rotationList"
            :key="index"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="product_rotation_content">
          <el-carousel
            ref="carousel"
            type="card"
            height="35.875rem"
            @change="swiper($event)"
          >
            <el-carousel-item v-for="item in rotationList" :key="item.id">
              <img :src="item.picture_url" width="100%" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div> -->

      <div style="display: flex; justify-content: center">
        <div
          @click="tasbclick(0)"
          :class="indextabs == 0 ? 'tabs' : ''"
          style="
            margin-right: 20.8333rem;
            width: 7.9167rem;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            style="width: 3rem; height: 5.9167rem"
            src="../assets/img/tabs1.png"
            alt=""
          />
          <p
            style="
              color: #333333;
              font-size: 1.6667rem;
              margin-top: 0.9167rem;
              margin-bottom: 0.6667rem;
            "
          >
            海马运动
          </p>
        </div>
        <div
          @click="tasbclick(1)"
          :class="indextabs == 1 ? 'tabs' : ''"
          style="
            width: 7.9167rem;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            style="width: 3rem; height: 5.9167rem"
            src="../assets/img/tabs2.png"
            alt=""
          />
          <p
            style="
              color: #333333;
              font-size: 1.6667rem;
              margin-top: 0.9167rem;
              margin-bottom: 0.6667rem;
            "
          >
            双减系统
          </p>
        </div>
      </div>

        <div class="hm-wrap" v-show="indextabs == 0">
          <div class="honor_title" style="margin-bottom: 50px">
            产品服务
          </div>
          <div class="flex">
            <div class="hm-btn" @click="toggleHm(index)" :class=" current == index ? 'hm-btn-ac' : ''" v-for="(item, index) in hmProductList" :key="index">
              {{item.title}}
            </div>
          </div>
          <el-carousel @change="hmChange" ref="hm" :initial-index="current" :interval="5000" type="card" height="41rem" indicator-position="none">
            <el-carousel-item v-for="(item, index) in hmProductList" :key="index">
              <img :src="item.picture_url" class="hm-pic" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      <div class="news_content" v-if="indextabs == 0">
      
        <div>
          <!-- 分1 -->
          <div class="news_content_item">
            <!-- 左侧 -->
            <div class="news_content_item_left">
              <div class="new_content_item_title">汇合海马运动</div>
              <div class="new_content_item_content" style="height: auto">
                海马运动是杭州汇合智能科技有限公司旗下运营的一款集运动课程、运动教练、运动场馆、运动产品、运动文化、运动信息化、运动品牌等为一体的运动全产业链，面向成人的运动生态系统。
                <div
                  style="display: flex; color: #161616; margin-top: 0.8333rem"
                >
                  <div>主要产品：</div>
                  <div>
                    <p style="margin: 0">海马运动用户端</p>
                    <p style="margin: 0">海马运动教练局</p>
                    <p style="margin: 0">海马运动机构端</p>
                  </div>
                </div>
              </div>
              <div class="new_content_item_button">
                <a
                  target="_blank"
                  style="color: #fff; text-decoration: none"
                  href="http://www.joingp.net"
                  >查看详情</a
                >
              </div>
            </div>

            <!-- 右侧 -->
            <div class="news_content_item_right">
              <img src="../assets/img/hmyd1.png" width="100%" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="news_content" v-if="indextabs == 1">
        <div v-for="(item, index) in introduceList" :key="index">
          <!-- 分1 -->
          <div v-if="index % 2 == 0" class="news_content_item">
            <!-- 左侧 -->
            <div class="news_content_item_left">
              <div class="new_content_item_title">{{ item.title }}</div>
              <div class="new_content_item_content">
                {{ item.content }}
                <div
                  style="display: flex; color: #161616; margin-top: 0.8333rem"
                >
                  <div>主要产品：</div>
                  <div v-if="index == 0" style="display: flex">
                    <div>
                      <p style="margin: 0">汇合教育综合管理系统</p>
                      <p style="margin: 0">汇合教育综合大屏系统</p>
                    </div>
                  </div>
                  <div v-if="index == 2" style="display: flex">
                    <div>
                      <p style="margin: 0">汇合课后服务系统</p>
                      <p style="margin: 0">汇合课后服务大屏展示系统</p>
                      <p style="margin: 0">汇合智慧校园管理系统</p>
                      <p style="margin: 0">汇合智慧校园班主任端</p>
                      <p style="margin: 0">汇合智慧校园老师端端</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="new_content_item_button">
                <a
                  target="_blank"
                  style="color: #fff; text-decoration: none"
                  :href="item.name"
                  >查看详情</a
                >
              </div>
            </div>
            <!-- 右侧 -->
            <div class="news_content_item_right">
              <img :src="item.picture_url" width="100%" alt="" />
            </div>
          </div>
          <!-- 分2 -->
          <div v-else class="news_content_item">
            <!-- 左侧 -->
            <div class="news_content_item1_left">
              <img :src="item.picture_url" width="100%" alt="" />
            </div>
            <!-- 右侧 -->
            <div class="news_content_item1_right">
              <div class="new_content_item_title">{{ item.title }}</div>
              <div class="new_content_item_content">
                {{ item.content }}
                <div
                  style="display: flex; color: #161616; margin-top: 0.8333rem"
                >
                  <div>主要产品：</div>
                  <div v-if="index == 1" style="display: flex">
                    <div style="margin-right: 4.1667rem">
                      <p style="margin: 0">汇合校外机构监管系统</p>
                      <p style="margin: 0">汇合校外机构大屏监管系统</p>
                      <p style="margin: 0">汇合培训机构管理系统</p>
                      <p style="margin: 0">汇合培训机构管理系统老师端</p>
                    </div>
                    <div style="">
                      <p style="margin: 0">教付保机构端</p>
                      <p style="margin: 0">教付保老师端</p>
                      <p style="margin: 0">教付保班主任端</p>
                      <p style="margin: 0">教付保</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="new_content_item_button">
                <a style="color: #fff; text-decoration: none" :href="item.name"
                  >查看详情</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 1.0833rem 0;
          height: 6.6667rem;
          background-color: #0d70ee;
          color: #ffffff;
          font-size: 1.1667rem;
          text-align: center;
        "
      >
        <p style="margin: 0">提供优质产品解决方案</p>
        <p style="margin: 0">咨询服务热线：0571-81869713</p>
      </div>
      <!-- 产品 -->
      <div class="news_product">
        <!-- 标题 -->
        <div>
          <el-dropdown @command="handleCommand">
            <span class="news_product_title">
              {{ newsProductTitle }}
            </span>
            <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
            <el-dropdown-menu slot="dropdown"> </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="news_product_swiper">
          <swiper ref="mySwiper" :options="swiperOptions">
            <transition v-for="(item, index) in productList" :key="index">
              <swiper-slide v-if="item.title == '海马运动' ? false : true">
                <div class="news_product_swiper_img">
                  <img :src="item.picture_url" height="100%" alt="" />
                </div>
                <div class="news_product_swiper_title">{{ item.title }}</div>
                <div class="news_product_swiper_content">
                  {{ item.content }}
                </div>
              </swiper-slide>
            </transition>

            <!-- <div class="swiper-button-prev prev-next-btn" slot="button-prev"></div>
            <div class="swiper-button-next prev-next-btn" slot="button-next"></div> -->
          </swiper>
        </div>
      </div>
    </div>
    <!-- 新闻动态 -->
    <div class="body">
      <!-- 新闻头部 -->
      <!-- <div class="news_top">
        <div class="sanjiao"></div>
        <div class="news_title">
          互联网+大数据精细化管理 — — 服务用户放心选择
        </div>
        <div class="news_title1">{{ NewsTop.title }}</div>
        <div class="news_phone">{{ NewsTop.content }}</div>
      </div>
      <div class="sanjiao1"></div> -->
      <!-- 总 -->
      <!-- 新闻动态 -->
      <div class="news_dynamic">
        <div class="news_dynamic_title">
          新闻动态
          <div class="news_dynamic_z"><p></p></div>
          <div class="news_dynamic_d">NEWS</div>
        </div>
        <div class="news_dynamic_items">
          <div
            class="news_dynamic_item"
            v-for="item in newDynamicList"
            :key="item.id"
          >
            <div class="news_dynamic_item_img">
              <img :src="item.picture_url" width="100%" height="100%" alt="" />
            </div>
            <div class="news_dynamic_item_title">{{ item.title }}</div>
            <div class="news_dynamic_item_b">
              {{ item.content }}
            </div>
          </div>
        </div>
        <div class="news_dynamic_button" @click="moreNews">查看更多</div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="body about">
      <div style="height: 2rem"></div>
      <div class="about_title">
        关于我们
        <div class="about_z"><p></p></div>
        <div class="about_d">ABOUT&emsp;US</div>
      </div>
      <div class="about_content">
        {{ aboutContent }}
      </div>
      <div style="height: 5rem"></div>
    </div>
    <!-- 汇合事迹 -->
    <div class="body history">
      <div class="history_title">汇合大事记</div>
      <div class="wrapper">
        <div
          :class="index % 2 == 0 ? 'box-right box-area' : 'box-area'"
          v-for="(item, index) in historyList"
          :key="index"
        >
          <div class="custom"></div>
          <div class="box-date">
            <span>{{ item.memorabilia_time }}</span>
          </div>
          <div class="box-text">
            <h2>{{ item.title }}</h2>
            <p>
              {{ item.content }}
            </p>
            <div>
              <img
                v-if="item.picture_url != ''"
                :src="item.picture_url"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 荣誉资质 -->
    <div class="honor">
      <div class="honor_title" style="margin-bottom: 50px">汇合荣誉资质</div>
      <el-carousel :interval="5000" type="card" height="41rem">
        <el-carousel-item v-for="(item, index) in honorImg" :key="index">
          <img :src="item.picture_url" width="50%" height="100%" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 企业文化 -->
    <div class="culture">
      <div class="culture_title">企业文化</div>
      <div class="culture_item">
        <img :src="cultureUrl" width="100%" height="100%" alt="" />
      </div>
    </div>
    <!-- 团队风采 -->
    <div>
      <div class="culture_title">团队风采</div>
      <div class="culture_carousel">
        <el-carousel :interval="1500" type="card" height="37rem">
          <el-carousel-item v-for="(item, index) in tdList" :key="index">
            <img :src="item.picture_url" width="100%" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 底部 -->
    <div>
      <div class="foot">
        <div style="display: flex; width: 100%; height: 90%">
          <div class="foot_left">
            <div class="foot_left_img">
              <img
                src="../assets/img/logo.png"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
          </div>
          <div class="foot_right">
            <dl v-for="item in footList" :key="item.id">
              <dt>{{ item.title }}</dt>
              <dt v-for="items in item.entities" :key="items.id">
                <a
                  style="color: #fff; text-decoration: none"
                  href="items.picture_url"
                  >{{ items.title }}</a
                >
              </dt>
            </dl>
            <!-- <dl>
              <dt>服务与支持</dt>
              <dd>科技服务</dd>
              <dd>智能服务</dd>
              <dd>人才服务</dd>
              <dd>帮助中心</dd>
            </dl>
            <dl>
              <dt>快速链接</dt>
              <dd>监管系统</dd>
              <dd>管理系统</dd>
              <dd>服务系统</dd>
              <dd>客户端</dd>
            </dl>
            <dl>
              <dt>关于我们</dt>
              <dd>关于我们</dd>
              <dd>公司历程</dd>
              <dd>企业文化</dd>
              <dd>团队风采</dd>
            </dl>
            <dl>
              <dt>联系我们</dt>
              <dd>售前咨询</dd>
              <dd>售后服务</dd>
              <dd>智能服务</dd>
              <dd>服务邮箱</dd>
            </dl> -->
          </div>
        </div>
        <div>
          Copyright© 2021 杭州汇合智能科技有限公司
          <a
            style="color: #fff; text-decoration: none"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            >{{ icpBeiAn }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      current:0,
      indextabs: 0,
      url: "/message/officialWebsiteHuiHe/queryListPage?status=2&type=",
      // ICP备案
      icpBeiAn: "",
      newsProductTitle: "其他产品",
      // 头部导航
      headlist: [
        {
          id: 0,
          title: "首页",
        },
        {
          id: 1,
          title: "产品服务",
        },
        {
          id: 2,
          title: "新闻动态",
        },
        {
          id: 3,
          title: "关于我们",
        },
        {
          id: 4,
          title: "汇合事迹",
        },
      ],
      swiperOptions: {
        slidesPerView: 4, //显示个数
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // 首页图片
      mainUrl: "",
      headIndex: 0,
      notNextTick: true,
      honorImg: "",
      swiperIndex: 0,
      swiperIndexs: 0,
      // 轮播列表 产品服务
      rotationList: [],
      // 产品
      productList: [],
      // 关于我们
      aboutContent: "",
      // 解决方案
      introduceList: [],
      //海马运动
      hmProductList: [],
      // 新闻动态
      newDynamicList: [],
      // 汇合大事记
      historyList: [],
      // 企业文化
      cultureUrl: "",
      NewsTop: {},
      // 团队风采
      tdList: [],
      // 底部列表
      footList: [],
      // 滚动距离
      jumps: [],

      newsPage: 1,
    };
  },
  mounted: function () {
    this.getMainUrl();
    this.getRotation();
    this.getAbout();
    this.getIntroduce();
    this.getHmSportProduct();

    this.getNewDynamic();
    this.getHistory();
    this.getCultureUrl();
    this.getNewsTop();
    this.product();
    this.getTd();
    this.geFoot();
    this.getIPC();
    this.swiper.slideTo(3, 1000, false);
    window.addEventListener("scroll", this.handleScroll, false);
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  beforeUpdate() {},
  destroyed() {
    window.addEventListener("scroll", this.handleScroll, false);
  },
  methods: {
    toggleHm(v){
      this.$refs.hm.setActiveItem(v)
      this.current = v
    },
    hmChange(v){
      this.current = v
    },
    tasbclick(v) {
      this.indextabs = v;
    },

    handleCommand(command) {
      this.newsProductTitle = command;
    },
    product() {
      this.$fetch(this.url + this.newsProductTitle).then((res) => {
        this.productList = res.data;
      });
    },
    // 监听
    jianT() {
      let jump = document.querySelectorAll(".body");
      for (let i = 0; i < 5; i++) {
        // 获取需要滚动的距离
        if (jump[i]) {
          this.jumps[i] = jump[i].offsetTop - 200;
        }
      }
    },

    handleScroll() {
      this.jianT();
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      if (top < this.jumps[1]) {
        this.headIndex = 0;
      } else if (top < this.jumps[2]) {
        this.headIndex = 1;
      } else if (top < this.jumps[3]) {
        this.headIndex = 2;
      } else if (top < this.jumps[4]) {
        this.headIndex = 3;
      } else {
        this.headIndex = 4;
      }
      // 60 780 1675 2570 3734
    },
    getMainUrl() {
      this.$fetch(this.url + "首页&pageSize=1").then((res) => {
        this.mainUrl = res.data[0].picture_url;
      });
    },
    getIPC() {
      this.$fetch(this.url + "备案号").then((res) => {
        this.icpBeiAn = res.data[0].title;
        this.jianT();
      });
    },
    // 产品服务
    getRotation() {
      this.$fetch(this.url + "产品服务").then((res) => {
        this.rotationList = res.data;
      });
    },

    // 产品服务
    getHmSportProduct() {
      this.$fetch(this.url + "海马运动产品").then((res) => {
        this.hmProductList = res.data;
      });
    },
    // 关于我们
    getAbout() {
      this.$fetch(this.url + "关于我们").then((res) => {
        this.aboutContent = res.data[0].content;
      });
    },
    // 解决方案
    getIntroduce() {
      this.$fetch(this.url + "解决方案").then((res) => {
        this.introduceList = res.data;
      });
    },
    // 新闻头部
    getNewsTop() {
      this.$fetch(this.url + "新闻头部&pageSize=1").then((res) => {
        this.NewsTop = res.data[0];
      });
    },
    // 新闻动态
    getNewDynamic() {
      this.$fetch(
        this.url + "新闻动态&pageSize=3&currentPage=" + this.newsPage
      ).then((res) => {
        this.newDynamicList = this.newDynamicList.concat(res.data);
        if (res.data.length == 0) {
          this.$message("没有更多了");
        }
      });
    },
    moreNews() {
      this.newsPage++;
      this.getNewDynamic();
    },
    // 企业文化
    getCultureUrl() {
      this.$fetch(this.url + "企业文化&pageSize=1").then((res) => {
        this.cultureUrl = res.data[0].picture_url;
      });
      this.$fetch(this.url + "荣誉资质&pageSize=100").then((res) => {
        this.honorImg = res.data;
        console.log(res.data, "123");
      });
    },
    // 汇合大事记
    getHistory() {
      this.$fetch(this.url + "汇合大事记").then((res) => {
        res.data.forEach((item) => {
          let items = item;
          let year = item.memorabilia_time.slice(0, 4);
          let month = item.memorabilia_time.slice(5, 7);
          items.memorabilia_time = year + "年" + month + "月";
          this.historyList.push(items);
        });
      });
    },
    getTd() {
      this.$fetch(this.url + "团队风采").then((res) => {
        this.tdList = res.data;
      });
    },
    geFoot() {
      this.$fetch(
        "/message/officialWebsiteHuiHe/queryFinalList?status=2&type=底部列表"
      ).then((res) => {
        this.footList = res.data;
      });
    },

    // 头部跳转
    head(index) {
      this.headIndex = index;
      let jump = document.querySelectorAll(".body");
      // console.log(jump[index].offsetTop - 80);
      // 获取需要滚动的距离
      let total = jump[index].offsetTop - 80;
      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
    // 关联轮播
    swiper(e) {
      this.swiperIndex = e;
    },
    // 手动切换
    swipers(index) {
      this.swiperIndexs = index;
      // console.log(this.$refs);
      this.$refs.carousel.setActiveItem(index);
    },
  },
};
</script>
<style scoped>
.tabs {
  border-bottom: 0.3333rem solid #014397;
}

.index_gw {
  width: 100%;
}
/* 顶部 */
.head {
  width: 100%;
  height: 5rem;
  display: flex;
  z-index: 20;
  position: fixed;
  background: #fff;
}
.head_logo {
  flex: 1;
  position: absolute;
  left: 20%;
  top: 50%;
  transform: translate(0, -50%);
}
.head_title {
  width: 50%;
  /* flex: 1; */
  position: absolute;
  right: 10%;
  top: 50%;
  display: flex;
  transform: translate(0, -50%);
}
.head_title_div1 {
  flex: 1;
  width: 100%;
  height: 2.5rem;
  font-size: 1.25rem;
  line-height: 2.5rem;
  border-radius: 1.25rem;
  margin: 0.625rem;
  text-align: center;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #fff;
  background-color: #1b57ec;
}
.head_title_div1:hover {
  color: #fff;
}
.head_title_div {
  flex: 1;
  width: 100%;
  height: 2.5rem;
  font-size: 1.25rem;
  line-height: 2.5rem;
  border-radius: 1.25rem;
  margin: 0.625rem;
  text-align: center;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #2b2b2b;
}
.head_title_div:hover {
  color: #1b57ec;
}
/* 产品服务 */
.product_head {
  margin: 3%;
  text-align: center;
}
.product_title {
  height: 2.165625rem;
  color: #014397;
  font-size: 2.5rem;
  line-height: 2.165625rem;
}
.product_title_item {
  font-size: 1.1667rem;
  color: #212121;
  height: 3rem;
  line-height: 3rem;
}
.product_rotation {
  margin: 0 0 1.625rem 0;
}

.product_rotation_title {
  display: flex;
  height: 3.125rem;
  line-height: 3.125rem;
  justify-content: center;
  text-align: center;
  font-size: 1rem;
  color: #fff;
  font-weight: normal;
  margin: 1.25rem;
}
.swiper_pagination {
  height: 100%;
  width: 100%;
}
.product_rotation_title_name {
  margin: 0.3125rem;
  height: 100%;
  width: 10%;
  border-radius: 0.5rem;
  background: #014397;
}
.product_rotation_title_name1 {
  margin: 0.3125rem;
  height: 100%;
  width: 10%;
  border-radius: 1.25rem;
  background: #014397;
}
.product_rotation_content {
  width: 90%;
  margin: 0 auto;
}
/* 深入样式 */
.product_rotation_content >>> .el-carousel__indicators--outside {
  display: none;
}
.news_top {
  height: 15rem;
  background: #014397;
  text-align: center;
  line-height: 3rem;
}
.sanjiao {
  margin: 0 auto;
  width: 0px;
  border-top: 3.125rem solid #fff;
  border-left: 3.75rem solid #014397;

  border-right: 3.75rem solid #014397;
}
.sanjiao1 {
  margin: 0 auto;
  width: 0px;
  border-top: 1.5625rem solid #014397;

  border-left: 1.875rem solid #fff;

  border-right: 1.875rem solid #fff;
}
.news_title {
  font-size: 2.25rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #ffffff;
}
.news_title1 {
  margin-top: 1.25rem;
  font-size: 1.5rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #ff6500;
}
.news_phone {
  font-size: 1rem;
  color: #fff;
}
.news_content {
  margin: 0 auto;
  background-color: #f8f8f8;
  padding: 0 20.8333rem;
}
.news_content_item {
  display: flex;
  padding-bottom: 5.8333rem;
  align-items: center;
}
.news_content_item_left {
  flex: 2;
  width: 100%;
}
.news_content_item_right {
  flex: 1;
  width: 100%;
  padding: 3.125rem;
}
.news_content_item1_left {
  flex: 1;
  width: 100%;
  padding: 3.125rem;
}
.news_content_item1_right {
  flex: 2;
  width: 100%;
}
.new_content_item_title {
  height: 1.9375rem;
  font-size: 2rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #ff6500;
  line-height: 1.625rem;
  /* text-align: center; */
  margin: 1rem;
  margin-top: 4.125rem;
}
.new_content_item_content {
  height: auto;
  font-size: 1rem;
  margin: 1rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #161616;
  line-height: 1.875rem;
}
.new_content_item_button {
  text-align: center;
  width: 10.4375rem;
  line-height: 2.625rem;
  font-size: 1rem;
  height: 2.625rem;
  background: #0d70ee;
  border-radius: 1.3125rem;
  color: #fff;
  border: 0;
  margin: 0 auto;
}
.news_product {
  margin: 0 auto;
  text-align: center;
  width: 80%;
}
.news_product_title {
  text-align: center;
  height: 2.375rem;
  font-size: 2.5rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #014397;
  line-height: 2.1875rem;
  margin: 5.8333rem 0;
  display: block;
}
.swiper-slide {
  margin: 0 auto;
  height: 23rem;
}

.prev-next-btn {
  width: 0.5rem;
  height: 1rem;
  --swiper-navigation-size: 2rem;
}

.news_product_swiper_img {
  width: 16.875rem;
  height: 11.875rem;
  margin: 0 auto;
}
.news_product_swiper_title {
  width: 16.875rem;
  font-size: 0.75rem;
  margin: 0 auto;
  text-align: left;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #0962c6;
  line-height: 1.875rem;
}
.news_product_swiper_content {
  width: 16.875rem;
  font-size: 1.2rem;
  margin: 0 auto;

  text-align: left;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #252525;
  line-height: 1.5625rem;
}

.news_dynamic {
  margin: 0 auto;
}
.news_dynamic_title {
  text-align: center;
  font-size: 2.875rem;
  font-family: 59;
  font-weight: 400;
  color: #3c77f0;
  margin: 1.25rem;
}
.news_dynamic_z {
  position: relative;
  margin: 0 auto;
  width: 17.5625rem;
  height: 0.125rem;
  background: #dedede;
  margin-top: 0.3125rem;
}
.news_dynamic_z p {
  position: absolute;
  margin: 0;
  width: 2.6875rem;
  height: 0.5rem;
  background: #4f4f4f;
  border-radius: 0.25rem;
  left: 50%;
  top: -150%;
  transform: translate(-50%, 0);
}
.news_dynamic_d {
  font-size: 1.25rem;
  margin-top: 0.3125rem;
  font-family: 59;
  font-weight: 400;
  color: #737373;
}
.news_dynamic_items {
  width: 75rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 0 auto;
}
.news_dynamic_item {
  margin: 1.25rem;
  width: 22.625rem;
  height: 27.4375rem;
  background: #ffffff;
  box-shadow: darkgrey 0.625rem 0.625rem 1.875rem 0.3125rem;
}
.news_dynamic_item_img {
  height: 12.5rem;
}
.news_dynamic_item_title {
  margin: 0.625rem;
  font-size: 1.25rem;
  font-family: SimHei;
  font-weight: 400;
  color: #363636;
}
.news_dynamic_item_b {
  margin: 0.625rem;
  margin-top: 1.8125rem;

  font-size: 1.25rem;
  font-family: SimHei;
  font-weight: 400;
  color: #9f9f9f;
  text-indent: 2em;
}
.news_dynamic_button {
  margin: 5% auto;
  text-align: center;
  font-size: 1rem;
  line-height: 2.875rem;
}
.news_dynamic_button {
  color: #fff;
  border: 0;
  width: 11.1875rem;
  height: 2.875rem;
  background: #3361b6;
  border-radius: 1.4375rem;
}
.about {
  width: 100%;
  /* height: 53.3125rem; */
  background: url("../assets/img/about.png") no-repeat;
  background-size: 100% 100%;
}
.about_title {
  text-align: center;
  font-size: 2.875rem;
  font-family: 59;
  font-weight: 400;
  color: #fff;
}
.about_z {
  position: relative;
  margin: 0 auto;
  width: 17.5625rem;
  height: 0.125rem;
  background: #dedede;
  margin-top: 0.3125rem;
}
.about_z p {
  position: absolute;
  margin: 0;
  width: 2.6875rem;
  height: 0.5rem;
  background: #4f4f4f;
  border-radius: 0.25rem;
  left: 50%;
  top: -150%;
  transform: translate(-50%, 0);
}
.about_d {
  font-size: 1.25rem;
  margin-top: 0.3125rem;
  font-family: 59;
  font-weight: 400;
  color: #737373;
}
.about_content {
  /* height: 28.75rem; */
  width: 60%;
  margin: 4.375rem auto;
  font-size: 1.5rem;
  font-family: SimHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 3rem;
  text-align: center;
}

.about_button {
  margin: 0 auto;
  text-align: center;
  border: 0;
  width: 12.5rem;
  height: 2.9375rem;
  font-size: 1rem;
  line-height: 2.9375rem;
  background: #ffffff;
  border-radius: 1.4375rem;
  color: #3361b6;
}
.history {
  margin: 0 auto;
  margin-top: 2.5rem;
}
.history_title {
  font-size: 2.5rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #014397;
  line-height: 2.1875rem;
  text-align: center;
  margin: 3.75rem;
}

.wrapper {
  font-family: roboto;
  display: flex;
  flex-wrap: wrap;
  max-width: 50rem;
  margin: 0 auto;
}

.box-area {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  width: 100%;
}

.box-date {
  display: flex;
  /* 原来是用渐变做的直线 */
  background: linear-gradient(
    to right,
    #fff 47%,
    #1b91ff 50%,
    #1b91ff 50%,
    #fff 47%
  );
  order: 2;
  text-align: center;
  font-size: 1.75rem;
  flex-basis: 6.25rem;
  color: #fff;
}
.box-date:first-child {
  background: linear-gradient(to right, #fff 47%, #fff 50%, #fff 50%, #fff 47%);
}
.box-date > span {
  width: 8.4375rem;
  height: 1.9375rem;
  background: linear-gradient(90deg, #206cff, #34d1fd);
  border-radius: 1rem;
  margin: auto 0.625rem;
  font-size: 1.0625rem;
  font-weight: 400;
  line-height: 1.9375rem;

  /* background: #1b91ff; */
}
.box-text {
  /* text-align: center; */
  padding: 1.25rem;
  /* color: #45f3ff; */
  order: 3;
  width: 80%;
  padding-left: 0.625rem;
  background: #f1f1f1;
  margin-bottom: 3%;
}

.box-text h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 400;
}

.box-text p {
  font-size: 0.875rem;
  font-weight: 400;
  color: #666666;
}
* {
  box-sizing: border-box;
}
@media (min-width: 40rem) {
  .box-text,
  .custom {
    width: 40%;
  }
  .box-right .box-text {
    order: 1;
    padding-right: 0.625rem;
  }
  .box-right .custom {
    order: 3;
  }
}
.honor {
  margin: 0.625rem auto;
  text-align: center;
}
.honor_title {
  height: 2.3125rem;
  font-size: 2.5rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #014397;
  line-height: 2.1875rem;
}
.honor_img {
  margin: 2.625rem auto;
  width: 80%;
}
.culture {
  width: 100%;
}
.culture_title {
  font-size: 2.5rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #014397;
  line-height: 2.1875rem;
  text-align: center;
  margin: 3.75rem;
}
.culture_item {
  margin: 0.625rem auto;
  width: 80%;
}
.culture_carousel {
  width: 70%;
  margin: 0 auto;
}

/* 底部 */
.foot {
  text-align: center;
  color: #fff;
  height: 19rem;
  background: url("../assets/img/break.png");
  background-size: 100%;
}

.foot_left {
  flex: 1;
  width: 100%;
  text-align: center;
  margin: auto;
}
.foot_left_img {
  height: 7.5625rem;
  width: 7.5625rem;
  margin: 0 auto;
}
.foot_right {
  flex: 2;
  display: flex;
  margin-left: 6.25rem;
  margin-top: 3rem;
}
.foot_right dt {
  width: 6.25rem;
  font-size: 1rem;
  text-align: center;
}
.foot_right dd {
  margin: 0.4375rem;
  color: #a9a9a9;
  font-size: 0.875rem;
  text-align: center;
}
.hm-wrap{
  background-color: #fff;
  width:100vw;
  padding: 2rem 18%;
  text-align: center;
  margin-top: 1rem;
}
.hm-pic{
  width: 23rem;
  height: 40rem;
}

.flex{
  display: flex;
  justify-content: center;
}
.hm-btn{
  width: 8rem;
  height: 2rem;
  line-height: 2rem;
  border-radius: 1rem;
  border:1px solid #0962c6;
  color: #0962c6;
  font-size: 0.8rem;
  text-align: center;
  margin-left: 10px;
}
.hm-btn-ac{
background-color: #0962c6;
color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue